import React from 'react';
import { FaGem } from 'react-icons/fa';

const points = [
  "तुम्ही इन्फ्लुएंसर आहात? मग हो, हे तुमच्यासाठीच आहे.",
  "तुमचं छोटं बिझनेस आहे? मग हो, हे तुमच्यासाठीच आहे",
  "तुम्हाला फॉलोअर्स वाढवायचंय? मग हो, हे तुमच्यासाठीच आहे.",
  "इंस्टाग्रामवरून पैसे कमवायचं स्वप्न आहे? मग हो, हे तुमच्यासाठीच आहे.",
  "सोशल मिडिया कसं काम करतं हे शिकायला वेळ नाही? मग हो, हे तुमच्यासाठीच आहे.",
  "Influencer व्हायचंय, पण सुरुवात कशी करावी? मग हो, हे तुमच्यासाठीच आहे",
  
];

const WorkshopPoints = () => {
  return (
    <div style={{ backgroundColor: '#f1e7e7', padding: '60px 20px' }}>
      <h2 style={{
        textAlign: 'center',
        fontSize: '34px',
        fontWeight: 'bold',
        marginBottom: '40px',
        fontFamily: 'outfit, sans-serif'
      }}>
        ही PDF नक्की कोणासाठी आहे?
      </h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '15px',
          maxWidth: '1000px',
          margin: '0 auto',
          paddingTop: '10px'
        }}
      >
        {points.slice(0, 6).map((point, idx) => (
          <div
            key={idx}
            style={{
              backgroundColor: '#e8fff0',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '10px',
              padding: '20px',
              fontSize: '15px',
              lineHeight: '1.6',
              border: '1px solid #c4ebd6',
              fontFamily: 'poppins, sans-serif'
            }}
          >
            <FaGem style={{ color: 'red', fontSize: '20px', marginTop: '5px' }} />
            <span>{point}</span>
          </div>
        ))}

        {/* Last full-width point
        <div
          style={{
            gridColumn: '1 / -1',
            backgroundColor: '#e8fff0',
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '20px',
            fontSize: '15px',
            lineHeight: '1.6',
            border: '1px solid #c4ebd6',
            fontFamily: 'poppins, sans-serif',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <FaGem style={{ color: '#27c36f', fontSize: '12px' }} />
          <span>{points[6]}</span>
        </div> */}
      </div>
    </div>
  );
};

export default WorkshopPoints;
